// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-select {
  font-size: 13px;
  --vs-border-color: rgb(var(--color-stroke));
}
.vs__clear {
  margin-right: 0;
}
.vs__open-indicator {
  cursor: pointer;
}

.vs__selected-options > input::-moz-placeholder {
  opacity: 1;
  color: #b2b1b9;
  font-size: 13px;
}

.vs__selected-options > input::placeholder {
  opacity: 1;
  color: #b2b1b9;
  font-size: 13px;
}

.vs__selected-options > input:-ms-input-placeholder {
  color: #b2b1b9;
  font-size: 13px;
}

.vs__selected-options > input::-ms-input-placeholder {
  color: #b2b1b9;
  font-size: 13px;
}

:root {
  --vs-dropdown-max-height: 250px;
  --vs-dropdown-z-index: 10000;
  --vs-font-size: 13px;
  --vs-colors--dark: rgba(var(--color-input));
}

.vs__dropdown-menu {
  max-height: 200px !important;
  min-width: 90px !important;
  padding-bottom: 0;
}
.vs__selected-options {
  padding: 3px 2px 2px 2px;
}

.v-select[data-selected='true']:not(.vs--open) .vs__search {
  width: 1px;
  flex-grow: 0;
  position: absolute;
}
.v-select[data-selected='true']:not(.vs--open) .vs__search:disabled {
  display: none;
}

.v-select--drop-up {
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color);
  border-bottom-style: none;
  border-radius: var(--vs-border-radius) var(--vs-border-radius) 0 0;
  box-shadow: 0px -3px 6px 0px var(--vs-colors--darkest);
}

.vs--drop-up .vs__dropdown-toggle {
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color);
  border-top-style: none;
  border-radius: 0 0 var(--vs-border-radius) var(--vs-border-radius);
}

.v-select.vs--unsearchable[data-selected='true'] .vs__search {
  width: 1px;
  position: absolute;
  left: 0;
  top: 0;
}
.vs--single.vs--loading.vs--unsearchable[data-selected='true'] .vs__selected,
.vs--single.vs--open.vs--unsearchable[data-selected='true'] .vs__selected {
  position: relative;
}

.vs__dropdown-option--highlight {
  width: -moz-max-content;
  width: max-content;
  min-width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
